import type { SelectItemType } from "@/components/base/select/select";
import type { AssetGeometryIcons } from "@/services/asset/asset.types";

export type ValidatedAssetGeometryIcons = {
	type: string;
	icon: string;
};

export function formatGeometryTypeLabel(value: string): string {
	return value
		.split(/[\s_-]+/)
		.filter(Boolean)
		.map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
		.join(" ");
}

export function filterValidAssetGeometryIcons(
	options: AssetGeometryIcons[] | undefined,
): ValidatedAssetGeometryIcons[] {
	if (!options?.length) return [];
	return options.flatMap((row) => {
		const type = row.type?.trim();
		const icon = row.icon?.trim();
		if (!type || !icon) return [];
		return [{ type, icon }];
	});
}

export function toGeometrySelectItems(
	options: ValidatedAssetGeometryIcons[],
): SelectItemType[] {
	return options.map(({ type }) => ({
		id: type,
		label: formatGeometryTypeLabel(type),
	}));
}
